var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from '../clients/axios';
export function getPartners() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield axios.get('/0/cms/web-partners');
            return response.data;
        }
        catch (err) {
            throw err;
        }
    });
}
export function getTeam() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield axios.get('/0/cms/web-team');
            return response.data;
        }
        catch (err) {
            throw err;
        }
    });
}
export function getTestimonials({ locale = 'sk' }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield axios.get('/0/cms/web-testimonials', {
                headers: {
                    'Accept-Language': locale,
                },
            });
            return response.data;
        }
        catch (err) {
            throw err;
        }
    });
}
export function getCompanyLogos() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield axios.get('/0/cms/web-company-logos');
            return response.data;
        }
        catch (err) {
            throw err;
        }
    });
}
